import Link from "next/link";
import { useI18n } from "@/i18n";

export function FooterSection() {
  const { t } = useI18n();

  return (
    <footer className="w-full border-t border-[#e5e5e5] bg-[#f8f8f8]">
      <div className="mx-auto max-w-[1152px] px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2.5">
          <img src="/logo.png" alt="Govilo" className="w-6 h-6 rounded object-cover" />
          <span className="text-sm text-[#7a818e]">Govilo</span>
        </div>
        <div className="flex flex-wrap items-center gap-5 text-xs text-[#b0b4ba]">
          <Link href="/guide/sell-digital-content-with-crypto" className="hover:text-[#7a818e] transition-colors">Guide</Link>
          <Link href="/skills" className="hover:text-[#7a818e] transition-colors">Skills</Link>
          <Link href="/terms" className="hover:text-[#7a818e] transition-colors">{t.home.terms}</Link>
          <Link href="/support" className="hover:text-[#7a818e] transition-colors">{t.home.support}</Link>
          <span className="text-[#e5e5e5]">|</span>
          <span>&copy; {new Date().getFullYear()}</span>
        </div>
      </div>
    </footer>
  );
}
